import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
// Chakra imports
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  Tooltip,
  useColorModeValue,
} from '@chakra-ui/react';
// Custom components
import DefaultAuth from 'layouts/auth/variants/Default';
// Assets
import illustration from 'assets/img/avatars/LogoAtlantis.png';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import { useAuth } from 'contexts/auth.context';
import { useNavigate } from 'react-router-dom';
import { adminLogin, validityLogin } from 'utils/admin/adminService';
import OnToast from 'components/alerts/toast';
import { HashLoader } from 'react-spinners';

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';

  const textColorError = useColorModeValue('red.500', 'red');
  const brandStars = useColorModeValue('brand.500', 'brand.400');

  const [show, setShow] = React.useState(false);
  const [formData, setFormData] = React.useState({
    email: '', // DEFAULT Auth HERE (email)
    password: '', // DEFAULT Auth HERE (password)
  });
  const [error, setError] = React.useState('');
  const [alert, setAlert] = useState(false);
  const [msg, setMsg] = useState<string>('');
  const [toastStatus, setToastStatus] = useState<string>('');
  const token = localStorage.getItem('user');
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleClick = () => setShow(!show);

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleLogin = async (event: any) => {
    event.preventDefault();

    let data = JSON.stringify(formData);

    const userDetails = JSON.parse(localStorage.getItem('user'));

    if (formData?.email === '' || formData?.password === '') {
      setMsg('Please Enter the  Username And Password');
      setToastStatus('error');
      setAlert(true);
      return false;
    }

    setLoading(true);
    try {
      const result = await adminLogin(data);
      if (result?.status !== 'Success') {
        setMsg('Incorrect Username Or Password');
        setToastStatus('error');
        setAlert(true);
        return false;
      }
let valid = {
  data: result?.data,
  token: result?.token,
  role: result?.role,
  expiration: result?.expiration,
};

// SAVE TOKEN FIRST
localStorage.setItem('token', result?.token);

const validityData = {
  id: result?.data?.id,
  token: result?.token,
  role: result?.data?.role,
};

const validityResult = await validityLogin(validityData);
      // let valid = {
      //   data: result?.data,
      //   token: result?.token,
      //   role: result?.role,
      //   expiration: result?.expiration,
      // };

      // const validityData = {
      //   id: result?.data?.id,
      //   token: result?.token,
      //   role: result?.data?.role,
      // };

      // const validityResult = await validityLogin(validityData);
      if (validityResult?.status === 'Success' || validityResult?.success) {
        //kishore
        let user = JSON.stringify(valid);

        // ## Set the user details in state and localStorage
        setUser(user);
        localStorage.setItem('user', user);

        // ## Parse the userDetails from localStorage
        const userDetails = JSON.parse(localStorage.getItem('user'));

        // ## Check the role and navigate accordingly
        if (userDetails?.data?.role === 'Creator') {
          // navigate("/admin/superadmin/game/home");
          // navigate("/admin/superadmin/learner");
          navigate("/admin/superadmin/Learner_activity");
          // navigate('/admin/dashboards');
        } else if (userDetails?.data?.role === 'Admin') {
          navigate("/admin/superadmin/customer");
          // navigate('/admin/dashboards');
          // navigate("/admin/superadmin/game/home");

        }

        // ## Reload the page
        window.location.reload();
      } else {
        console.error('Validity check failed:', validityResult.message);

        setMsg(
          'Your plan has expired. Please reach out to LeadUpp for renewal or extension of access.',
        );
        setToastStatus('error');
        setAlert(true);
        return false;
      }
    } catch (error) {
      console.error('Error during login process:', error);
      setMsg('An error occurred. Please try again later.');
      setToastStatus('error');
      setAlert(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backdropFilter: 'blur(10px)',
          }}
        >
          <HashLoader color="#3b38e0" />
        </div>
      )}
      <DefaultAuth illustrationBackground={illustration} image={illustration}>
        <Flex
          maxW={{ base: '100%', md: 'max-content' }}
          w="100%"
          mx={{ base: 'auto', lg: '0px' }}
          me="auto"
          h="100%"
          alignItems="start"
          justifyContent="center"
          mb={{ base: '30px', md: '60px' }}
          px={{ base: '25px', md: '0px' }}
          mt={{ base: '40px', md: '14vh' }}
          flexDirection="column"
        >
          <Box me="auto">
            <Heading color={textColor} fontSize="36px" mb="15px">
              Sign In
            </Heading>
          </Box>
          {user && user?.token ? (
            <>
              <Text
                fontSize="xl"
                color={textColor}
                fontWeight="bold"
                textAlign="center"
                mb="22px"
              >
                Hi {user?.data?.name}! Welcome back—you're already signed in.
              </Text>
              <Button
                fontSize="sm"
                // onClick={() => navigate('/admin/dashboards/default')}
                onClick={() => navigate('/admin/superadmin/game/home')}
                variant="brand"
                fontWeight="500"
                w="100%"
                h="50"
                mb="24px"
              >
                Go To Dashboard
              </Button>
            </>
          ) : (
            <Flex
              zIndex="2"
              direction="column"
              w={{ base: '100%', md: '420px' }}
              maxW="100%"
              background="transparent"
              borderRadius="15px"
              mx={{ base: 'auto', lg: 'unset' }}
              me="auto"
              mb={{ base: '20px', md: 'auto' }}
            >
              <FormControl>
                <FormLabel
                  display="flex"
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Email<Text color={brandStars}>*</Text>
                </FormLabel>
                <Input
                  isRequired={true}
                  variant="auth"
                  fontSize="sm"
                  ms={{ base: '0px', md: '0px' }}
                  type="email"
                  placeholder="mail@simmmple.com"
                  mb="24px"
                  fontWeight="500"
                  size="lg"
                  name="email"
                  onChange={handleChange}
                  value={formData?.email}
                />
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  display="flex"
                >
                  Password<Text color={brandStars}>*</Text>
                </FormLabel>
                <InputGroup size="md">
                  <Input
                    isRequired={true}
                    fontSize="sm"
                    placeholder="Min. 8 characters"
                    mb="24px"
                    size="lg"
                    type={show ? 'text' : 'password'}
                    variant="auth"
                    name="password"
                    onChange={handleChange}
                    value={formData?.password}
                  />
                  <Tooltip label={show ? 'Hide Password' : 'Show Password'}>
                    <InputRightElement
                      display="flex"
                      alignItems="center"
                      mt="4px"
                    >
                      <Icon
                        color={textColorSecondary}
                        _hover={{ cursor: 'pointer' }}
                        as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                        onClick={handleClick}
                      />
                    </InputRightElement>
                  </Tooltip>
                </InputGroup>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                    }}
                  >
                    <Checkbox id="remember-login" colorScheme="brandScheme" />
                    <FormLabel
                      htmlFor="remember-login"
                      mb="0"
                      fontWeight="normal"
                      color={textColor}
                    >
                      Keep me logged in
                    </FormLabel>
                  </div>

                  <Text fontWeight="400" fontSize="14px">
                    <NavLink to="/forgotPassword">
                      <Text
                        as="span"
                        style={{
                          color: '#422AFB',
                        }}
                        fontWeight="500"
                      >
                        Forgot Password
                      </Text>
                    </NavLink>
                  </Text>
                </div>
                <Flex justifyContent="center" align="center" mb="24px">
                  <Text
                    color={textColorError}
                    fontSize="sm"
                    w="124px"
                    fontWeight="500"
                  >
                    {error}
                  </Text>
                </Flex>
                <Button
                  fontSize="sm"
                  onClick={handleLogin}
                  variant="brand"
                  fontWeight="500"
                  w="100%"
                  h="50"
                  mb="24px"
                >
                  Sign In
                </Button>
              </FormControl>
              <Flex
                flexDirection="column"
                justifyContent="center"
                alignItems="start"
                maxW="100%"
                mt="0px"
              ></Flex>
            </Flex>
          )}
        </Flex>
      </DefaultAuth>
      {alert ? (
        <OnToast msg={msg} status={toastStatus} setAlert={setAlert} />
      ) : null}
    </>
  );
}

export default SignIn;
